import angular from 'angular';
import gridHeight from '../core/shared-service/grid-utils';
import _ from 'lodash';

class listPaymentsCtrl {
    /*  @ngInject */
    constructor(PAYMENT, PaymentFilter, PaymentSvc, logger, UtilSvc, $scope, $sessionStorage, $translate) {
        this.PAYMENT = PAYMENT;
        this.PaymentFilter = PaymentFilter;
        this.PaymentSvc = PaymentSvc;
        this.logger = logger;
        this.UtilSvc = UtilSvc;
        this.$scope = $scope;
        this.$sessionStorage = $sessionStorage;
        this.$translate = $translate;
    }

    $onInit() {
        this.buyerTypeList = this.PAYMENT.buyer_type;
        // On retire le statut 'STARTED' est est propre au requests
        this.statuses = _.reject(this.PAYMENT.status, s => s.value === 'STARTED');

        this.searchData =
            this.keepSearchData && this.$sessionStorage.listPaymentFilter
                ? this.$sessionStorage.listPaymentFilter
                : new this.PaymentFilter();

        this._initSearchDateTime();

        this.gridOptions = {
            columnDefs: this.PAYMENT.columnDefs,
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            enableSorting: false,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => this.onRegisterApi(gridApi),
        };

        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }

    // Grille
    onRegisterApi(gridApi) {
        this.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
            this.searchData.setPageSize(size);
            this.searchData.setPage(page - 1);
            this.search();
        });
    }

    _initSearchDateTime() {
        if (!this.searchData.createdTimeFrom) {
            this.searchData.createdTimeFrom = new Date();
            this.searchData.createdTimeFrom.setHours(0, 0, 0, 0);
        }

        if (!this.searchData.createdTimeTo) {
            this.searchData.createdTimeTo = new Date();
            this.searchData.createdTimeTo.setHours(23, 59, 0, 0);
        }

        if (!this.searchData.updatedTimeFrom) {
            this.searchData.updatedTimeFrom = new Date();
            this.searchData.updatedTimeFrom.setHours(0, 0, 0, 0);
        }

        if (!this.searchData.updatedTimeTo) {
            this.searchData.updatedTimeTo = new Date();
            this.searchData.updatedTimeTo.setHours(23, 59, 0, 0);
        }
    }

    search() {
        if (this.form.$valid) {
            this.$sessionStorage.listPaymentFilter = this.searchData;

            this.searchData.createdDateFrom = this.UtilSvc.mixteDateTime(
                this.searchData.createdDateFrom,
                this.searchData.createdTimeFrom
            );

            this.searchData.createdDateTo = this.UtilSvc.mixteDateTime(
                this.searchData.createdDateTo,
                this.searchData.createdTimeTo
            );

            this.searchData.updatedDateFrom = this.UtilSvc.mixteDateTime(
                this.searchData.updatedDateFrom,
                this.searchData.updatedTimeFrom
            );

            this.searchData.updatedDateTo = this.UtilSvc.mixteDateTime(
                this.searchData.updatedDateTo,
                this.searchData.updatedTimeTo
            );

            //enregistrer le filtre de recherche formaté pour l'export
            this.preparedSearchFilter = this.searchData.preparBeforeSearch();
            var searchResult = this.PaymentSvc.searchPayments(this.preparedSearchFilter);
            this.paymentsPromise = searchResult;
            searchResult.then(
                pagePayments => {
                    this.gridOptions.data = pagePayments.payments;
                    this.gridOptions.totalItems = pagePayments.totalItems;
                },
                (/*error*/) => {
                    this.logger.error('error.search');
                }
            );
        }
    }

    clearForm() {
        // Reset data
        this.searchData = new this.PaymentFilter();
        this._initSearchDateTime();
        // Recherche
        this.search();
    }

    isAvailableDataToExport() {
        return !!this.gridOptions.data && this.gridOptions.data.length > 0;
    }
}

angular.module('app.payment').component('listPayments', {
    templateUrl: require('./list-payments.html'),
    controller: listPaymentsCtrl,
    bindings: {
        keepSearchData: '<',
    },
});
